// extracted by mini-css-extract-plugin
module.exports = {"root":"StoryStrip_root__3bawM","li":"StoryStrip_li__2kh9x"};